import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDividerModule } from '@angular/material/divider';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { DataService } from '../../services/data.service';
import { UsageSummaryResponse } from '../../models/usage';

@Component({
  selector: 'app-usage-summary-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule, MatDividerModule, MatDialogModule],
  templateUrl: './usage-summary-dialog.component.html',
  styleUrls: ['./usage-summary-dialog.component.scss']
})
export class UsageSummaryDialogComponent implements OnInit {
  loading = true;
  error: string | null = null;
  usage: UsageSummaryResponse | null = null;

  constructor(
    private dialogRef: MatDialogRef<UsageSummaryDialogComponent>,
    private dataService: DataService
  ) {}

  ngOnInit(): void {
    this.loadUsage();
  }

  loadUsage(): void {
    this.loading = true;
    this.error = null;
    this.dataService.getUsageSummary().subscribe({
      next: (res) => {
        // API may return PascalCase; map to expected shape if necessary
        this.usage = res as UsageSummaryResponse;
        this.loading = false;
      },
      error: (err) => {
        console.error('Failed to load usage summary', err);
        this.error = 'Failed to load usage details';
        this.loading = false;
      }
    });
  }

  getValueOrUnlimited(value: number | null | undefined): string {
    if (value === -1) {
      return 'Unlimited';
    }
    return value?.toString() ?? 'N/A';
  }

  close() {
    this.dialogRef.close();
  }
}
